import React, { useState, useRef, useEffect } from "react";
import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import Spinner from "components/Loader/Spinner";
import { ALERT } from "src/constants/images";
import * as icon from "services/icon";

const WarningFloorPrice = ({
  __handleSellGangsta__,
  onClose,
  isVisible,
  salePrice,
  floorPrice,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="floorPriceWaring card "
    >
      <div className="header px-4 py-3">
        Are you sure?
        <div
          onClick={() => onClose()}
          onKeyPress={(e) => e.code == "Enter" && onClose()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} alt="close" />
        </div>
      </div>
      <div className="floorPriceWarningBody px-4 py-2">
        <img src={ALERT.SOURCE} />
        <p>
          You are about to list this item for{" "}
          <span className="bold"> {salePrice} ICX</span> which is{" "}
          <span className="red bold">
            {(((floorPrice - salePrice) * 100) / floorPrice).toFixed(1)}% below
            the floor price.
          </span>{" "}
        </p>
      </div>
      <div className="mcg-footer px-2 py-2">
        <div className="d-flex">
          <button className="cancel" onClick={() => onClose()}>
            Cancel
          </button>
          <button
            className="complete"
            onClick={() => {
              onClose();
              __handleSellGangsta__(salePrice);
            }}
          >
            Complete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningFloorPrice;
